import React, { useState, useContext } from 'react'
import "./TopBar.scss";
import { shareFacebook, shareWhatsapp, openNegishut } from '../../Services/Sharing';
import { AppContext } from '../../Stores/App.store';

const TopBar = () => {
    const { pageView } = useContext(AppContext)!;
    const [shareOpen, setShareOpen] = useState<boolean>(false);

    

    return (
        <div className={`topbar ${shareOpen ? "open" : ""}`}>
            <div className="ynet" onClick={() => window.open("https://www.ynet.co.il/", "_blank")}></div>
            {pageView === "content" && <h4>נזכרים בטיולים</h4>}
            <div className="negishut" onClick={openNegishut}></div>
            <div className="share" onClick={() => setShareOpen(!shareOpen)}></div>
            <div className="facebook" onClick={shareFacebook}></div>
            <div className="whatsapp" onClick={shareWhatsapp}></div>
        </div>
    )
}

export default TopBar
